import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { DateDisplay } from '@/components/ui/DateDisplay';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { CalendarIcon } from 'lucide-react';
import React from 'react';
import { FieldComponentProps } from './types';

const FieldView = ({ value }: { value?: null | string }) => {
  return <DateDisplay value={value} />;
};

// TODO: Allow clearing date when allowed by schema
export const DateField: React.FC<FieldComponentProps> = ({
  formMode,
  controllerField,
}) => {
  if (formMode === 'loading') {
    return <Skeleton className="h-8 w-full" />;
  }

  if (formMode === 'edit') {
    return (
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant={'outline'}
            className={cn(
              'h-8 w-full justify-start px-2 text-left text-sm font-normal',
              !controllerField.value && 'text-muted-foreground',
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {controllerField.value ? (
              <DateDisplay value={controllerField.value} />
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0">
          <Calendar
            mode="single"
            selected={controllerField.value}
            onSelect={controllerField.onChange}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    );
  }

  return <FieldView value={controllerField.value} />;
};
